class ShippingInfo extends HTMLElement {
  constructor() {
    super();
    this.dateElement = null;
    this.flagElement = null;
    this.codeElement = null;
    this.rightPill = null;
    this.config = {
      days: 2,
      includeWeekend: true,
      locale: 'hr',
      allowAllCountries: true,
      shopCountry: '',
    };
  }

  connectedCallback() {
    this.dateElement = this.querySelector('[data-ref="ship-date"]');
    this.flagElement = this.querySelector('[data-ref="country-flag"]');
    this.codeElement = this.querySelector('[data-ref="country-code"]');
    this.rightPill = this.querySelector('[data-ref="right-pill"]');

    this.#loadConfiguration();
    this.#renderShipDate();
    this.#detectAndApplyCountry();
  }

  #loadConfiguration() {
    const days = parseInt(this.dataset.days, 10);
    this.config.days = Number.isFinite(days) && days >= 0 ? days : 2;
    this.config.includeWeekend = this.dataset.includeWeekend === 'true';
    this.config.locale = this.dataset.locale || 'hr';
    this.config.allowAllCountries = this.dataset.allowAllCountries === 'true';
    this.config.shopCountry = (this.dataset.shopCountry || '').toUpperCase();
  }

  #renderShipDate() {
    if (!this.dateElement) return;
    const shipDate = this.#calculateShipDate(this.config.days, this.config.includeWeekend);
    this.dateElement.textContent = this.#formatDate(shipDate);
  }

  async #detectAndApplyCountry() {
    const code = await this.#fetchVisitorCountry();
    if (!code) return;
    this.#applyCountry(code);
  }

  async #fetchVisitorCountry() {
    try {
      const res = await fetch('/browsing_context_suggestions.json', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) return null;
      const data = await res.json();
      const handle = data?.detected_values?.country?.handle;
      return handle ? handle.toUpperCase() : null;
    } catch {
      return null;
    }
  }

  #applyCountry(code) {
    if (!this.config.allowAllCountries && code !== this.config.shopCountry) {
      if (this.rightPill) this.rightPill.hidden = true;
      return;
    }

    if (this.rightPill) this.rightPill.hidden = false;

    if (this.flagElement) {
      const lower = code.toLowerCase();
      this.flagElement.src = `https://cdn.jsdelivr.net/npm/flag-icons/flags/4x3/${lower}.svg`;
      this.flagElement.alt = code;
    }
    if (this.codeElement) {
      this.codeElement.textContent = code;
    }
  }

  #calculateShipDate(daysToAdd, includeWeekend) {
    const date = new Date();

    if (includeWeekend) {
      date.setDate(date.getDate() + daysToAdd);
      return date;
    }

    let added = 0;
    while (added < daysToAdd) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) {
        added++;
      }
    }

    while (date.getDay() === 0 || date.getDay() === 6) {
      date.setDate(date.getDate() + 1);
    }

    return date;
  }

  #formatDate(date) {
    const options = {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
    };

    try {
      return new Intl.DateTimeFormat(this.config.locale, options).format(date);
    } catch {
      return new Intl.DateTimeFormat('hr', options).format(date);
    }
  }
}

if (!customElements.get('shipping-info')) {
  customElements.define('shipping-info', ShippingInfo);
}
